<template>
  <section>
    <div>
      <router-link :to="{ name: 'kabaddiSeason', params: {key: seasonKey}}">Season</router-link>
      <router-link :to="{ name: 'kabaddiSeasonSchedule', params: {key: seasonKey}}">Schedule</router-link>
      <router-link :to="{ name: 'kabaddiSeasonRounds', params: {key: seasonKey}}">Rounds</router-link>
      <router-link :to="{ name: 'kabaddiSeasonPointsTable', params: {key: seasonKey}}">Points Table</router-link>
      <router-link :to="{ name: 'kabaddiSeasonStats', params: {key: seasonKey}}">Stats</router-link>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    seasonKey: String,
    showSeason: {
      type: Boolean,
      default: false
    }
  }
}
</script>
